<script setup>
import { Head, Link } from '@inertiajs/inertia-vue3';
import { BookOpen, ArrowRight } from 'lucide-vue-next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/Components/ui/card';
import { Button } from '@/Components/ui/button';

defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
});
</script>

<template>
    <Head title="Trang chủ" />

    <div class="flex min-h-screen flex-col items-center justify-center bg-muted px-4 py-12">
        <Card class="w-full max-w-lg">
            <CardHeader class="items-center space-y-4 text-center">
                <div class="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-primary-foreground">
                    <BookOpen class="h-7 w-7" />
                </div>
                <CardTitle class="text-3xl">
                    <span class="font-bold">Đông Tây</span> ERP
                </CardTitle>
                <CardDescription>
                    Hệ thống quản lý chuỗi nhà sách — kho, tài chính, công nợ và hoa hồng.
                </CardDescription>
            </CardHeader>

            <CardContent class="flex flex-col items-center gap-3">
                <template v-if="canLogin">
                    <Button v-if="$page.props.user" as-child class="w-full sm:w-auto">
                        <Link :href="route('dashboard')">
                            Vào Dashboard
                            <ArrowRight class="ml-2 h-4 w-4" />
                        </Link>
                    </Button>

                    <template v-else>
                        <Button as-child class="w-full sm:w-auto">
                            <Link :href="route('login')">
                                Đăng nhập
                                <ArrowRight class="ml-2 h-4 w-4" />
                            </Link>
                        </Button>
                        <Button v-if="canRegister" as-child variant="outline" class="w-full sm:w-auto">
                            <Link :href="route('register')">Đăng ký tài khoản</Link>
                        </Button>
                    </template>
                </template>
            </CardContent>
        </Card>
    </div>
</template>
